
    <button type="button" class="btn btn-primary btn-sm" (click)="view()" style="font-size: 12px;width: 70px;"> <i class="far fa-file"></i> View
    </button>